/**
 * Os quatro números do topo da tela de caixa.
 *
 * Saiu de dentro de `TelaCaixa.tsx` porque a tela do turno aberto e a ficha do
 * turno fechado mostram os MESMOS quatro indicadores — e, enquanto o
 * componente morava dentro de uma delas, a segunda ia nascer com uma cópia
 * ligeiramente diferente.
 */
import { Icone, type NomeIcone } from '../../../componentes/Icone'
import { formatarMoeda, type Centavos } from '../../../plataforma/dinheiro'

export function CartaoIndicador({
  rotulo,
  icone,
  valor,
  detalhe,
  tom = 'neutro',
}: {
  rotulo: string
  icone: NomeIcone
  valor: Centavos
  detalhe?: string
  /** `erro` pinta quebra; `ok`, sobra. O neutro é o caso normal. */
  tom?: 'neutro' | 'ok' | 'erro'
}) {
  const cor =
    tom === 'erro' ? 'text-erro' : tom === 'ok' ? 'text-ok' : 'text-tinta'

  return (
    <div className="rounded-sistema border border-borda bg-superficie px-5 py-[18px] shadow-[var(--shadow-cartao)]">
      <div className="mb-3.5 flex items-center justify-between">
        <span className="text-[13px] text-texto-suave">{rotulo}</span>
        <span className="flex h-8 w-8 items-center justify-center rounded-sistema bg-marca-fundo-2 text-marca">
          <Icone nome={icone} tamanho={19} />
        </span>
      </div>

      <div className={`tabular mb-2 font-titulo text-[28px] font-bold ${cor}`}>
        {formatarMoeda(valor)}
      </div>

      {detalhe && <p className="text-[12px] leading-[1.45] text-texto-fraco">{detalhe}</p>}
    </div>
  )
}
